module.exports = __webpack_public_path__ + "static/media/for-kids.9a1c0b70.svg";